// Dependencies.
import styled from 'styled-components'

import { H3 } from '../../H3'
import { Hyperlink } from '../../Hyperlink'
import { CTA } from '../../CTA'
import { EventHookInterface } from '../../../types'
import { ModalContentWrapper } from '../../ModalContentWrapper'
import { fadeIn } from '../../../utils/keyframes'
import { colors, forScreensGreaterThanMobileWidth } from '../../../utils'
import { DateAndTime } from './DateAndTime'
import { H4 } from '../../H4'

// Div.
const Div = styled(ModalContentWrapper)`
  animation: ${fadeIn} 100ms ease;
  height: auto;

  ${forScreensGreaterThanMobileWidth`
    display: flex;
    justify-content: center;
    flex-direction: row-reverse;
    align-items: center;
    height: 470px;
  `}

  .eventSnapshot {
    display: flex;
    align-items: center;
    background: #fafafe;
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: 120px;
    .dateAndTitle {
      margin-left: 20px;
    }
    ${forScreensGreaterThanMobileWidth`
      height: 100%;
      width: 45%;
      display: block;
      .dateAndTitle { margin-left: 0px; }
    `}

    & .background {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      ${forScreensGreaterThanMobileWidth`
      height: 300px;
      margin-bottom: 20px;
    `}
    }
  }

  .eventSnapshot .coverImage {
    background-color: ${colors.white};
    background-position: center;
    background-size: cover;
    border-radius: 6px;
    width: 80px;
    height: 80px;
    object-fit: cover;
    flex-shrink: 0;
    ${forScreensGreaterThanMobileWidth`
    
    width: 100%;
    height: 100%; 
    `}
  }

  .eventSnapshot .dateAndTime {
    margin-bottom: 20px;
  }

  .content {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    ${forScreensGreaterThanMobileWidth`
      width: 55%;
    `}
  }

  .cateIcon {
    background: ${colors.white};
    box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.05);
    font-size: 36px;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .background {
    border-radius: 100px;

    ${forScreensGreaterThanMobileWidth`
      border-radius: 10px;
    `}
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Event Modal Content.
export const EventModalContentWrapper: React.FC<Props> = (props) => {
  // Props.
  const { children, eventHook } = props
  const { value } = eventHook
  const title = value.title || '-'
  const coverImage = value.image_url || value.image

  return (
    <Div>
      {/* Event Snapshot. */}
      <div className="eventSnapshot">
        {/* Cover Image. */}
        <div className="background">
          <style jsx>{`
            .background {
              background: ${value.category && value.category.background_colour
                ? value.category.background_colour
                : colors.white};
            }
          `}</style>
          {coverImage && <img className="coverImage" src={coverImage}></img>}
          {/* {!coverImage && <div className="cateIcon">{value.category && value.category.emoji || ''}</div>} */}
        </div>

        <div className="dateAndTitle">
          {/* Time. */}
          <DateAndTime dateTime={value.start_date} />

          {/* Title. */}
          <H4>{title}</H4>
        </div>
      </div>

      {/* Content. */}
      <div className="content">{children}</div>
    </Div>
  )
}
